<template>
  <div class="container-login">
    <div class="container-img">
      <img src="../assets/banner-3.png" alt="" srcset="" />
    </div>
    <form @submit.prevent="submit">
      <div class="container--logo">
        <img src="../assets/logo_ref.png" alt="" />
      </div>
      <span class="login100-form-title pb-2">
        Sé parte de la familia <strong>Referencia</strong>
      </span>
      <div class="mb-4">
        <label for="email">Usuario</label>
        <input
          id="user"
          class="form-control py-4 mb-2"
          v-validate="'required'"
          type="text"
          data-vv-validate-on="blur"
          data-vv-name="user"
          v-model="login.email"
          placeholder="referencia@example.com"
        />
        <span class="text-danger fs-6" v-show="errors.has('user')">
          Este campo es obligatorio
        </span>
      </div>

      <div class="mb-4">
        <label for="password" class="fw-bold">Contraseña</label>
        <input
          id="password"
          class="form-control py-4 mb-2"
          v-validate="'required'"
          type="password"
          data-vv-validate-on="blur"
          data-vv-name="password"
          v-model="login.password"
        />
        <span class="text-danger fs-6" v-show="errors.has('password')">{{
          errors.first("password")
        }}</span>
      </div>
      <div class="container-login100-form-btn mt-4 ">
        <button :disabled="loading" class="login100-form-btn">
          <b-spinner v-if="loading" class="mr-2" small></b-spinner>
          Iniciar sesión
        </button>
      </div>

      <div class="text-center mt-4 p-t-46 p-b-20 p-t">
        <button
          class="login100-form-btn login100-form-btn-outline "
          @click="goLogup"
        >
          Registrarse
        </button>
      </div>

      <div class="login100-form-social flex-c-m">
        <a href="#" class="login100-form-social-item flex-c-m bg1 m-r-5">
          <i class="fa fa-facebook-f" aria-hidden="true"></i>
        </a>

        <a href="#" class="login100-form-social-item flex-c-m bg2 m-r-5">
          <i class="fa fa-twitter" aria-hidden="true"></i>
        </a>
      </div>
      <b-alert
        class="mt-4"
        :show="responseError.time"
        dismissible
        fade
        variant="warning"
      >
        {{ responseError.message }}
      </b-alert>
    </form>
  </div>
</template>
<script>
export default {
  name: "Login",

  data() {
    return {
      loading: false,
      login: {
        email: "",
        password: "",
      },
      responseError: {
        message: "Usuario o contraseña incorrecto",
        dissmissed: false,
      },
    };
  },

  methods: {
    goLogup() {
      this.$router.push("/registro");
    },
    submit() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch({ type: "login/auth", data: this.login })
            .then(() => {
              if (
                this.$store.state.login.roles.includes("Admin") ||
                this.$store.state.login.roles.includes("SuperAdmin")
              ) {
                this.$router.push("/solicitudes");
              } else {
                this.$router.push("/");
              }
              this.loading = false;
            })
            .catch((e) => {
              this.$swal.fire("Error", `${e.message}`, "error");
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>
